// Barrel re-exporting the four user-action buckets. The original
// `@/lib/actions/users` import path stays valid for all callers.
//
// Each bucket file is itself the `'use server'` module that owns the
// actual Server Action declarations. This barrel deliberately does
// NOT carry a `'use server'` directive — Next.js 16's SWC checker
// rejects re-exports in a 'use server' file (it can't statically
// prove the re-exported binding refers to an async function).
// Without the directive, this is a plain ES module passing through
// the action references; Next.js still treats them as Server Actions
// because their original declaration lives in a 'use server' file.

export * from './users/crud';
export * from './users/password';
export * from './users/email-verification';
export * from './users/access-bindings';
